import { Address } from "@/types";
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay
} from "@chakra-ui/react";

type ChangeAddressModalProps = {
  clientId: string;
  clientAddress: Address[];
  isOpen: boolean;
  onClose: () => void;
};

function ChangeAddressModal({
  clientId,
  clientAddress,
  isOpen,
  onClose
}: ChangeAddressModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      closeOnOverlayClick={false}
    >
      <ModalOverlay />
      <ModalContent mx={["10px", "unset"]}>
        <ModalHeader>Altear endereço de entrega</ModalHeader>
        <ModalBody></ModalBody>
        <ModalFooter></ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export { ChangeAddressModal };
